var map = {
	"./openid_page_aima.png": 51547,
	"./openid_page_bolai.png": 49430,
	"./openid_page_bolai_h5.png": 26662,
	"./openid_page_leifeng.png": 32487,
	"./openid_page_qianniu.png": 9890,
	"./openid_page_qianniu_h5.png": 43165,
	"./openid_page_yuandian.png": 52792
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 62396;